<template>
    <div>
        <div class="vx-col w-full mb-base">
            <vs-card title="Add New Customer" class="p-4 mb-6">
                <div
                    slot="header"
                    class="flex flex-wrap items-center justify-between"
                >
                    <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                        <h4>Transactional Report</h4>
                    </div>
                    <div
                        class="flex flex-wrap items-center justify-between ag-grid-table-actions-right"
                    >
                        <vs-button
                            color="primary"
                            class="btn mb-4 md:mb-0 mr-1"
                            @click="submitForm"
                            >Process</vs-button
                        >
                    </div>
                </div>
                <div class="vx-row mt-6">
                    <div class="vx-col md:w-1/4 w-full">
                        <label class="vs-input--label"
                            >Client ID <span class="text-danger">*</span></label
                        >
                        <vs-select
                            class="selectExample"
                            v-model="form.client_id"
                            width="100%"
                            autocomplete
                            @input-change="searchDropdown($event, client)"
                        >
                            <vs-select-item
                                v-for="(item, index) in client.data"
                                :key="index"
                                :value="item.id"
                                :text="item.client_code"
                            />
                        </vs-select>
                    </div>
                </div>
                <div class="vx-row mt-6">
                    <div class="vx-col md:w-1/4 w-full">
                        <label class="vs-input--label"
                            >Warehouse ID
                            <span class="text-danger">*</span></label
                        >
                        <vs-select
                            class="selectExample"
                            v-model="form.warehouse_id"
                            width="100%"
                            autocomplete
                            @input-change="searchDropdown($event, warehouse)"
                        >
                            <vs-select-item
                                v-for="(item, index) in warehouse.data"
                                :key="index"
                                :value="item.id"
                                :text="item.warehouses_code"
                            />
                        </vs-select>
                    </div>
                </div>
                <div class="vx-row mt-6">
                    <div class="vx-col md:w-1/4 w-full">
                        <label class="vs-input--label"
                            >Period <span class="text-danger">*</span></label
                        >
                        <flat-pickr class="w-full" v-model="form.date" />
                    </div>
                </div>
            </vs-card>
        </div>
    </div>
</template>

<script>
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
    components: {
        vSelect,
        flatPickr,
    },
    data() {
        return {
            isLoading: false,
            isForm: false,
            file: null,
            reference: "",
            client: {
                data: [],
                loading: false,
                endpoint: "master/clients",
                objectKey: "client_code",
            },
            warehouse: {
                data: [],
                loading: false,
                endpoint: "master/warehouses",
                objectKey: "warehouses_code",
            },
            form: {
                client_id: null,
                warehouse_id: null,
                date: null,
            },
        };
    },
    watch: {
        isLoading: function () {
            if (this.isLoading) {
                this.$vs.loading();
            } else {
                this.$vs.loading.close();
            }
        },
    },
    methods: {
        submitForm() {
            if (this.form.client_id == null) {
                this.$vs.notify({
                    color: "danger",
                    title: "Error",
                    text: "Client ID is required",
                });

                return false;
            }

            if (this.form.warehouse_id == null) {
                this.$vs.notify({
                    color: "danger",
                    title: "Error",
                    text: "Warehouse ID is required",
                });

                return false;
            }

            if (this.form.date == null) {
                this.$vs.notify({
                    color: "danger",
                    title: "Error",
                    text: "Period is required",
                });

                return false;
            }

            this.isLoading = true;
            this.$http
                .post("support/transactional_report", this.form, {
                    responseType: "blob",
                })
                .then((res) => {
                    this.isLoading = false;

                    saveAs(res.data, "invoice-export.xlsx");
                })
                .catch((error) => this.handleError(error));
        },
    },
    mounted() {},
};
</script>